import { SVGProps } from "react";

export const CloudDownloadSVG = ({
  color = "currentColor",
  width,
  height,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 0.491455C14.2961 0.491575 17.0394 2.83724 17.6553 5.96118C20.0096 6.12417 21.866 8.06195 21.8662 10.4524C21.8662 12.9517 19.8382 14.9807 17.3389 14.9807H13.998V13.1692H17.3389C18.833 13.1691 20.0557 11.9465 20.0557 10.4524C20.0554 9.04902 18.9506 7.86329 17.5381 7.77271L16.1523 7.6731L15.8809 6.3147C15.419 3.98752 13.3725 2.3031 11 2.30298C9.13454 2.30298 7.45015 3.33532 6.58984 4.99243L6.13672 5.85278L5.16797 5.95239C3.3297 6.14255 1.94442 7.69082 1.94434 9.54712C1.94434 11.5484 3.56508 13.1692 5.56641 13.1692H7.99805V14.9807H5.56641C2.56894 14.9807 0.132812 12.5445 0.132812 9.54712C0.1329 6.74911 2.25188 4.44048 4.97754 4.15063C6.10951 1.97732 8.38288 0.491455 11 0.491455Z"
      fill={color}
    />
    <path
      d="M14.2233 18.3154L10.9993 21.5085L7.77539 18.3154"
      stroke={color}
      strokeWidth="1.8"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M10.9961 10.453L10.9961 20.4078"
      stroke={color}
      strokeWidth="1.8"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
